/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type DeleteDeliverablesRecordsForContainerMutationVariablesGQLType = Types.Exact<{
  containerId: Types.Scalars['UUID'];
}>;


export type DeleteDeliverablesRecordsForContainerMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<Types.MutationGQLType, 'deleteDeliverableRecordsForContainerId'>
);


export const DeleteDeliverablesRecordsForContainerDocumentGQLType = gql`
    mutation DeleteDeliverablesRecordsForContainer($containerId: UUID!) {
  deleteDeliverableRecordsForContainerId(containerId: $containerId)
}
    `;
export type DeleteDeliverablesRecordsForContainerMutationFnGQLType = Apollo.MutationFunction<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>;

/**
 * __useDeleteDeliverablesRecordsForContainerMutation__
 *
 * To run a mutation, you first call `useDeleteDeliverablesRecordsForContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliverablesRecordsForContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliverablesRecordsForContainerMutation, { data, loading, error }] = useDeleteDeliverablesRecordsForContainerMutation({
 *   variables: {
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useDeleteDeliverablesRecordsForContainerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>(DeleteDeliverablesRecordsForContainerDocumentGQLType, options);
      }
export type DeleteDeliverablesRecordsForContainerMutationHookResult = ReturnType<typeof useDeleteDeliverablesRecordsForContainerMutation>;
export type DeleteDeliverablesRecordsForContainerMutationResultGQLType = Apollo.MutationResult<DeleteDeliverablesRecordsForContainerMutationGQLType>;
export type DeleteDeliverablesRecordsForContainerMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>;